import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Tooltip } from "../../../../../revvComponents";

// Internal Imports
import { isTableCellMerged } from "../../../utils";
import { DOCUMENTS, IMAGE_URLS } from "../../../../../constants";

// import { emptyCell, addColumn, removeColumn } from "../../../methods";

// Destructuring
const { MAX_COLUMN_ALLOWED } = DOCUMENTS;
const { TableAddColumnRight, TableAddColumnLeft, TableRemoveColumn } =
  IMAGE_URLS;

class ColumnOptionBtns extends Component {
  state = {};

  _checkForMergeCells = rowData => {
    if (rowData.length === 1 && isTableCellMerged(rowData[0])) {
      return true;
    }
    if (rowData.length > 1) {
      return true;
    }
    return false;
  };

  _showColumnOptions = () => {
    const {
      readOnly,
      // focusRowID,
      // focusColumnID,
      component: { data: tableData },
    } = this.props;
    // check if there is any focus column or not
    // if (focusColumnID === undefined || focusColumnID === null || !tableData) {
    //   return null;
    // }
    const { data, attributes } = tableData;
    // if (data[focusRowID] === null || data[focusRowID] === undefined) {
    //   return null;
    // }
    const { data: rowData } = data[0];
    const showAddColumn = attributes.columnCount < MAX_COLUMN_ALLOWED;
    const showRemoveColumn = this._checkForMergeCells(rowData);
    return (showAddColumn || showRemoveColumn) && !readOnly ? (
      <div className="table-add-column columnoptionbtns-wrapper">
        <Fragment>
          {showAddColumn && (
            <div
              className={`table-add-column-items ${
                this.props.selectedRowId === null &&
                this.props.selectedColumnId !== null
                  ? "disabled-options"
                  : ""
              }`}>
              {/* Column Options */}
              <Tooltip
                placement="bottom"
                overlay="Add Column Left"
                align={{
                  offset: [0, 3],
                }}>
                <span
                  data-test="table-add-column-left-button-span"
                  className="revvtabletoolbar-btn btn-positive"
                  onMouseDown={e => this.props.addColumn("L", e)}
                  // onKeyDown={e => this._addColumn("L", e)}
                  role="button"
                  tabIndex={0}>
                  <img className="" src={TableAddColumnLeft} alt="Add Column" />
                </span>
              </Tooltip>
              <Tooltip
                placement="bottom"
                overlay="Add Column Right"
                align={{
                  offset: [0, 3],
                }}>
                <span
                  data-test="table-add-column-right-button-span"
                  className="revvtabletoolbar-btn btn-positive"
                  onMouseDown={e => this.props.addColumn("R", e)}
                  // onKeyDown={e => this._addColumn("R", e)}
                  role="button"
                  tabIndex={0}>
                  <img
                    className=""
                    src={TableAddColumnRight}
                    alt="Add Column"
                  />
                </span>
              </Tooltip>
            </div>
          )}
          {showRemoveColumn && (
            <Tooltip
              placement="bottom"
              overlay="Remove Column"
              align={{
                offset: [0, 3],
              }}>
              <span
                data-test="table-remove-column-button"
                className="revvtabletoolbar-btn btn-negative"
                onMouseDown={this.props.removeColumn}
                // onKeyDown={this._removeColumn}
                role="button"
                tabIndex={0}>
                <img className="" src={TableRemoveColumn} alt="Remove Column" />
              </span>
            </Tooltip>
          )}
        </Fragment>
      </div>
    ) : null;
  };

  _toggleDropdownHandler = () => {
    this.setState(prevState => ({
      showDropdown: !prevState.showDropdown,
    }));
  };

  render() {
    return <Fragment>{this._showColumnOptions()}</Fragment>;
  }
}

const mapStateToProps = state => {
  const { activeComponentMeta } = state.DocumentStore;
  let focusRowID = null;
  let focusColumnID = null;

  const { tableRowId, tableColId } = activeComponentMeta;

  focusRowID = tableRowId !== undefined ? tableRowId : null;
  focusColumnID = tableColId !== undefined ? tableColId : null;
  const activeCell =
    focusRowID !== undefined && focusColumnID !== undefined
      ? [focusRowID, focusColumnID]
      : null;

  return {
    focusRowID,
    focusColumnID,
    activeCell,
    activeComponentMeta,
  };
};

export default connect(mapStateToProps, null)(ColumnOptionBtns);
